export const isDev = process.env.NODE_ENV === 'development'
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT ?? ''
export const ASSETS_ENDPOINT = process.env.REACT_APP_ASSETS_ENDPOINT ?? ''
export const THUMBNAIL_ASSETS_ENDPOINT = process.env.REACT_APP_THUMBNAIL_ASSETS_ENDPOINT ?? ''
export const UPPY_ENDPOINT = process.env.REACT_APP_UPPY_ENDPOINT ?? ''
export const PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY ?? ''
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN ?? ''
export const MAPBOX_GL_TOKEN = process.env.REACT_APP_MAPBOX_GL_TOKEN ?? ''
